import type { Carrier } from '../api/types';
import { SHELVE_VALUES, CONFIRMED_VALUES, GDS_VALUES } from '../api/types';

interface Filters {
  carrier_code: string;
  fare_family: string;
  correct_shelve: string;
  wrong_shelve: string;
  confirmed: string;
  gds: string;
  booking_code: string;
  search: string;
}

interface Props {
  filters: Filters;
  onChange: (filters: Filters) => void;
  carriers: Carrier[];
}

export function FilterBar({ filters, onChange, carriers }: Props) {
  const set = (key: keyof Filters, value: string) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <div className="flex flex-wrap gap-2 items-end mb-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Search
        </label>
        <input
          type="text"
          value={filters.search}
          onChange={(e) => set('search', e.target.value)}
          placeholder="Search..."
          className="border border-gray-300 rounded px-2 py-1 text-sm w-40"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Carrier
        </label>
        <select
          value={filters.carrier_code}
          onChange={(e) => set('carrier_code', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value="">All</option>
          {carriers.map((c) => (
            <option key={c.code} value={c.code}>
              {c.code} - {c.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Fare Family
        </label>
        <input
          type="text"
          value={filters.fare_family}
          onChange={(e) => set('fare_family', e.target.value)}
          placeholder="e.g. ECONOMY"
          className="border border-gray-300 rounded px-2 py-1 text-sm w-32"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Correct Shelf
        </label>
        <select
          value={filters.correct_shelve}
          onChange={(e) => set('correct_shelve', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value="">All</option>
          {SHELVE_VALUES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Wrong Shelf
        </label>
        <select
          value={filters.wrong_shelve}
          onChange={(e) => set('wrong_shelve', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value="">All</option>
          {SHELVE_VALUES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Confirmed
        </label>
        <select
          value={filters.confirmed}
          onChange={(e) => set('confirmed', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value="">All</option>
          {CONFIRMED_VALUES.map((v) => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          GDS
        </label>
        <select
          value={filters.gds}
          onChange={(e) => set('gds', e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          <option value="">All</option>
          {GDS_VALUES.map((v) => (
            <option key={v} value={v}>
              {v === 's' ? 'Sabre' : 'Amadeus'}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Booking Code
        </label>
        <input
          type="text"
          value={filters.booking_code}
          onChange={(e) => set('booking_code', e.target.value)}
          placeholder="e.g. D,J"
          className="border border-gray-300 rounded px-2 py-1 text-sm w-24"
        />
      </div>
      <button
        onClick={() =>
          onChange({
            carrier_code: '',
            fare_family: '',
            correct_shelve: '',
            wrong_shelve: '',
            confirmed: '',
            gds: '',
            booking_code: '',
            search: '',
          })
        }
        className="px-3 py-1 text-sm bg-gray-200 hover:bg-gray-300 rounded"
      >
        Clear
      </button>
    </div>
  );
}
